import type { Budget } from 'types/costViews';
import { createDialogWithIdStore } from './createDialogWithIdStore';

export const useBudgetDialog = createDialogWithIdStore<Budget>();
